/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/light/range_selector.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { BLACK, CENTER, RED, WHITE } from "./contants";
export default {
  rangeSelector: {
    scale: {
      valueMarginsEnabled: true,
      width: 1,
      color: BLACK,
      opacity: .1,
      showCustomBoundaryTicks: true,
      label: {
        overlappingBehavior: "hide",
        alignment: CENTER,
        visible: true,
        topIndent: 7,
        font: {
          size: 11
        }
      },
      tick: {
        width: 1,
        color: BLACK,
        opacity: .17,
        visible: true,
        length: 12
      },
      minorTick: {
        width: 1,
        color: BLACK,
        opacity: .05,
        visible: true,
        length: 12
      },
      marker: {
        width: 1,
        color: "#000000",
        opacity: .1,
        visible: true,
        separatorHeight: 33,
        topIndent: 10,
        textLeftIndent: 7,
        textTopIndent: 11,
        label: {}
      },
      logarithmBase: 10,
      workWeek: [1, 2, 3, 4, 5],
      breakStyle: {
        width: 5,
        color: "#ababab",
        line: "waved"
      },
      endOnTick: false
    },
    selectedRangeColor: "#606060",
    sliderMarker: {
      visible: true,
      paddingTopBottom: 2,
      paddingLeftRight: 4,
      color: "#606060",
      invalidRangeColor: RED,
      font: {
        color: WHITE,
        size: 11
      }
    },
    sliderHandle: {
      width: 1,
      color: BLACK,
      opacity: .2
    },
    shutter: {
      opacity: .75
    },
    background: {
      color: "#c0bae1",
      visible: true,
      image: {
        location: "full"
      }
    },
    behavior: {
      snapToTicks: true,
      animationEnabled: true,
      moveSelectedRangeByClick: true,
      manualRangeSelectionEnabled: true,
      allowSlidersSwap: true,
      valueChangeMode: "onHandleRelease"
    },
    redrawOnResize: true,
    chart: {
      barGroupPadding: .3,
      minBubbleSize: 12,
      maxBubbleSize: .2,
      topIndent: .1,
      bottomIndent: 0,
      valueAxis: {
        inverted: false,
        logarithmBase: 10
      },
      commonSeriesSettings: {
        type: "area",
        aggregation: {
          enabled: void 0
        },
        point: {
          visible: false
        },
        scatter: {
          point: {
            visible: true
          }
        }
      }
    }
  }
};